import http from "../httpRequest";

class ProjectFormService {
    async createProject(data: any) {
        let response = await http.post("/forms/project", data,{
            headers:{'content-type':'multipart/form-data'},
            onUploadProgress(progressEvent) {
                if (progressEvent.progress !== undefined) {
                    const progress = Math.round(progressEvent.progress*100);
                    http.apiResponse.setUploadProgress(progress);	
                }
            },
        });
        http.apiResponse.resetUploadProgress();
        return response;
    }

    async deleteProject(id: string) {
        let response = await http.delete(`/forms/project/${id}`);
        return response?.data;
    }

    async getAllProjects() {
        let response = await http.get("/forms/project");
        return response?.data;
    }

    async getProject(id: string) {
        let response = await http.get(`/forms/project/${id}`);
        return response?.data;
    }

    async verifyProjectName(projectName: string) {
        let response = await http.post(`/forms/project/verifyName`, {
            projectName
        });
        return response?.data.exists;
    }
}

export default new ProjectFormService();